import { useState, useEffect } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { projectEditService, type ProjectEditForm } from '../services/projectEdit.service';
import { toast } from 'sonner';

export function useProjectEdit(id: string) {
  const queryClient = useQueryClient();
  const [form, setForm] = useState<ProjectEditForm | null>(null);

  const query = useQuery({
    queryKey: ['projects1', 'edit', id],
    queryFn: () => projectEditService.getProject(id),
    enabled: !!id,
  });

  useEffect(() => {
    if (query.data) {
      setForm(query.data);
    }
  }, [query.data]);

  const updateMutation = useMutation({
    mutationFn: (data: ProjectEditForm) => projectEditService.updateProject(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['projects1'] });
      toast.success('Đã cập nhật dự án thành công');
    },
    onError: (error: any) => {
      toast.error(`Lỗi khi cập nhật: ${error.message}`);
    }
  });

  const updateForm = (patch: Partial<ProjectEditForm>) => {
    if (!form) return;
    setForm(prev => prev ? ({ ...prev, ...patch }) : null);
  };

  return {
    form,
    updateForm,
    isLoading: query.isLoading,
    isSaving: updateMutation.isPending,
    saveProject: updateMutation.mutateAsync,
  };
}
